import { useTranslation } from 'react-i18next'
import { RouteChildrenProps } from 'react-router-dom'

import { PreConditionsForm3, diseasesForPage3, usePreConditionsLogic } from '@ana/shared'
import PageLayout from 'components/PageLayout'
import useSaveOnBack from 'hooks/useSaveOnBack'

import usePage from '../../hooks/usePage'

const PreConditions3Page: React.FC<RouteChildrenProps> = () => {
  const { initialValues = {}, onBack, ...page } = usePage()

  const { t } = useTranslation()

  const logic = usePreConditionsLogic({
    initialValues,
    diseases: diseasesForPage3,
  })

  const handleBack = () => onBack?.({ diseases: logic.selectedDiseases })

  const formikRef = useSaveOnBack({ onBack: handleBack })

  return (
    <PageLayout title={t('category.anamnesis')} subtitle={t('subcategory.pre_existing_conditions')}>
      <PreConditionsForm3 innerRef={formikRef} loading={false} initialValues={initialValues} logic={logic} {...page} />
    </PageLayout>
  )
}

export default PreConditions3Page
